<template>
  <div class="container">
    <div class="row row-xs mg-b-25">
      <div
        class="col-sm-4 col-md-3 col-lg-4 col-xl-3"
        v-for="(t, i) in prms.tasks"
        :key="i"
      >
        <div class="card">
          <img
            :src="
              `${myResBaseUrl}media/report/preview/${t.organizationTaskId}.png`
            "
            class="card-img-top"
            alt=""
          />
          <div class="card-body tx-13">
            <div>
              <h5>{{ t.task }}</h5>
              <router-link
                :to="{
                  name: 'reportList',
                  params: { ot: ot, edit: 0, detail: t.id }
                }"
                class="btn btn-block btn-white"
                >Харах</router-link
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    ot: {
      type: Number,
      default: () => 0
    },
    prms: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      myResBaseUrl: "https://res.gosmart.mn/"
    };
  },
  mounted() {
    if (
      this.$store.state.app.activeGroup.resBaseUrl != undefined &&
      this.$store.state.app.activeGroup.resBaseUrl != ""
    ) {
      this.myResBaseUrl = this.$store.state.app.activeGroup.resBaseUrl;
    }
  }
};
</script>

<style></style>
